import { component } from 'picoapp';

export default component((node, ctx) => {
  class MegaMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.topLevelItems = this.querySelectorAll('.Nav__link.level-1');
      this.bindEvents();
    }
    bindEvents() {
      let currentTarget;
      this.topLevelItems.forEach((item) => {
        let timeoutId;
        let target = item.parentNode.dataset.target;
        if (!target) return;
        ctx.on('broadcast-menu-action', (state) => {
          if (state.identifier == target && state.action == 'enter-submenu') {
            clearTimeout(timeoutId);
          }
          if (state.identifier == target && state.action == 'leave-submenu') {
            timeoutId = setTimeout(() => {
              ctx.emit('toggleMenuItem', { identifier: target, action: 'close' });
            }, 500);
          }
        });
        item.addEventListener('keydown', (ev) => {
          // ENTER
          if (ev.keyCode == 13) {
            ev.preventDefault();
            ev.stopPropagation();
            ctx.emit('toggleMenuItem', { identifier: target, action: 'toggle', origin: 'keyboard' });
          }
        });
        document.body.addEventListener('keyup', (ev) => {
          // ESCAPE
          if (ev.keyCode == 27) {
            ev.preventDefault();
            ev.stopPropagation();
            ctx.emit('toggleMenuItem', { identifier: target, action: 'close', origin: 'keyboard' });
          }
        });
        item.addEventListener('mouseenter', () => {
          clearTimeout(timeoutId);
          ctx.emit('toggleMenuItem', { identifier: target, action: 'open' });
        });
        item.addEventListener('mouseleave', () => {
          timeoutId = setTimeout(() => {
            ctx.emit('toggleMenuItem', { identifier: target, action: 'close' });
          }, 500);
        });
      });
    }
  }

  class MegaMenuItem extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.identifier = this.dataset.identifier;
      this.parentMenuItem = document.querySelector(`.Nav--main .Nav__item[data-target="${this.identifier}"]`);
      this.active = false;
      this.bindEvents();
    }

    bindEvents() {
      this.addEventListener('mouseenter', () => {
        ctx.emit('broadcast-menu-action', { identifier: this.identifier, action: 'enter-submenu' });
      });
      this.addEventListener('mouseleave', () => {
        ctx.emit('broadcast-menu-action', { identifier: this.identifier, action: 'leave-submenu' });
      });
      ctx.on('toggleMenuItem', (state) => {
        if (state.identifier === this.identifier) {
          switch (state.action) {
            case 'open':
              this.classList.add('is-open');
              this.parentMenuItem.classList.add('is-open');
              this.active = true;
              break;

            case 'close':
              this.classList.remove('is-open');
              this.parentMenuItem.classList.remove('is-open');
              if (this.active && state.origin == 'keyboard') {
                this.parentMenuItem.querySelector('a').focus();
              }
              this.active = false;
              break;

            case 'toggle':
              this.classList.toggle('is-open');
              this.parentMenuItem.classList.toggle('is-open');
              this.querySelector('figcaption a').focus();
              if (this.active && state.origin == 'keyboard') {
                this.parentMenuItem.querySelector('a').focus();
              }
              this.active = !this.active;
              break;

            default:
              break;
          }
        }
      });
    }
  }

  if (!customElements.get('mega-menu')) {
    customElements.define('mega-menu', MegaMenu);
  }
  if (!customElements.get('mega-menu-item')) {
    customElements.define('mega-menu-item', MegaMenuItem);
  }
});
